{
  "version": 1,
  "asset_id": "776899df-e3f9-4fff-98ea-386f137c879d",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/776899df-e3f9-4fff-98ea-386f137c879d/home-640.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/776899df-e3f9-4fff-98ea-386f137c879d/home-640.avif",
  "original_filename": "home-640.avif",
  "size": 15304,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:03:26Z"
}
